import { ContextType, UCMC_CONNECTION_NAME, UserContextManagerState } from '@dh-io-cscs/user-context-manager/dist';
import { initializeStore } from '@seamless/store';
import { Ref, ref } from 'vue';
import { infuse } from '../ioc-config';
import { getStorageItem, setStorageItem } from '../utils/persistence.util';

const USER_CONTEXT_KEY = 'user-context';
const userContext = ref<ContextType>();
const store = initializeStore();

const getUserContext = () => getStorageItem(USER_CONTEXT_KEY, infuse('config').b2xSwitch.default as ContextType);

const setUserContext = (context?: ContextType) => {
  userContext.value = context ?? getUserContext();
  (window as any).cscsUserContext = userContext.value;
  setStorageItem(USER_CONTEXT_KEY, userContext.value);
};

export const useUserContext = (context?: ContextType, force?: boolean): Ref<ContextType> => {
  if ((context && force) || !userContext.value) {
    setUserContext(context);
  }

  return userContext as Ref<ContextType>;
};

store.subscribe(UCMC_CONNECTION_NAME, (contextState: UserContextManagerState | null) => {
  setUserContext(contextState?.context);
});
